import { useMemo } from 'react';

interface UseThumbnailUrlProps {
  bookmarkId: string;
  hash: string | undefined;
  profileMode: boolean;
  ogImage?: string;
}

export function useThumbnailUrl({
  bookmarkId,
  hash: _hash,
  profileMode,
  ogImage,
}: UseThumbnailUrlProps) {
  const thumbnailUrl = useMemo(() => {
    // Prioritize og_image if available (like legacy template)
    if (ogImage) {
      return ogImage;
    }

    // In profile mode without hash, show placeholder
    if (profileMode) {
      return `https://picsum.photos/seed/${bookmarkId}/128/80`;
    }

    return undefined;
  }, [bookmarkId, profileMode, ogImage]);

  return thumbnailUrl;
}
